import COLORS from "../../theme/Colors";

export const variantStatus = [
    {
        id: "Completada",
        variant: "success"
    },
    {
        id: "Cancelada",
        variant: "rejected"
    },
    {
        id: "En proceso",
        variant: "inProcess"
    }
];

export const getStatusVariant = (statusName, statusId) => {
    const s = String(statusName || "").toLowerCase();
    const id = Number(statusId);

    if (id === 7 || id === 3 || s.includes("completad") || s.includes("aprobad") || s.includes("finalizad")) {
        return { variant: "success", color: "#10B981", bg: "#E6F4EA" };
    }
    if (id === 8 || id === 10 || s.includes("cancelad") || s.includes("rechazad")) {
        return { variant: "rejected", color: "#EF4444", bg: "#FEE2E2" };
    }
    if (id === 99 || s.includes("requerida") || s.includes("observacion") || s.includes("accion")) {
        return { variant: "warning", color: "#F59E0B", bg: "#FEF3C7" };
    }
    if (id === 5 || s.includes("pago")) {
        return { variant: "payment", color: "#8B5CF6", bg: "#F3E8FF" };
    }
    return { variant: "inProcess", color: "#2563EB", bg: "#EFF6FF" };
};

export const statusColors = {
    info: COLORS.notificationComplete,
    success: COLORS.notificationSuccess,
    warning: COLORS.notificationWarning,
    danger: COLORS.notificationError,
};